import React from "react";

function Twitch() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#A544FF"
        d="M12.652.655h-.054C5.985.655.625 6.017.625 12.632v.054c0 6.614 5.36 11.976 11.973 11.976h.054c6.613 0 11.973-5.362 11.973-11.976v-.054c0-6.615-5.36-11.977-11.973-11.977z"
      ></path>
      <path
        fill="#fff"
        d="M8.884 6.406L6.211 9.08v9.625h3.207v2.673l2.673-2.673h2.138l4.811-4.813V6.406H8.884zm9.087 6.951l-2.138 2.139h-2.139l-1.87 1.871v-1.871H9.417v-8.02h8.553v5.881z"
      ></path>
      <path
        fill="#fff"
        d="M16.367 9.348h-1.07v3.208h1.07V9.348zM13.427 9.348h-1.069v3.208h1.07V9.348z"
      ></path>
    </svg>
  );
}

export default Twitch;
